import {find, findOne, ready} from "@leap-spark/sparkies";
import Swiper, {Navigation, Scrollbar} from "swiper";
import {Loader} from "./lib/loader";
import './forms';
import './nav';

ready(() => {

    Loader.on({bodyClass: 'page-template-template-locations'}, () => {
        Swiper.use([Navigation]);

        const el = document.getElementById('location-map');
        const allPins = el.querySelectorAll('.map-pin');
        const resetPins = () => {
            allPins.forEach((pin: HTMLImageElement) => {
                pin.src = pin.dataset.default;
                pin.classList.remove('active');
            });
        };

        new Swiper('.location-swiper', {
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
            on: {
                slideChange: (swiper) => {
                    const index_currentSlide = swiper.realIndex;
                    const currentSlide = swiper.slides[index_currentSlide] as HTMLElement;

                    if (!currentSlide) {
                        return;
                    }

                    resetPins();

                    const city = currentSlide?.dataset.slideCity;
                    const cityPin = el.querySelector(`.map-pin--${city}`) as HTMLImageElement;

                    if (!cityPin) {
                        return;
                    }

                    cityPin.classList.add('active');
                    cityPin.src = cityPin.dataset.active;
                },
            }
        });
    });


    Loader.on(null, () => {

        if (!findOne('.swiper-news')) {
            return;
        }

        const yearCards = find('.swiper-slide .news-year');
        const yearWrappers = find('.year-wrapper');
        find('.js-year-select')?.forEach((element: HTMLButtonElement): void => {
            element.addEventListener('click', (e: MouseEvent): void => {
                e.preventDefault();
                const year = element.dataset.year;

                findOne(`#year-${year}`).classList.add('show');

                yearCards.forEach((card: HTMLElement) => {
                    if (card.dataset.year === year) {
                        card.classList.add('active');
                    } else {
                        card.classList.remove('active');
                    }
                });

                yearWrappers.forEach((element: HTMLElement) => {
                    if (element.id !== `year-${year}`) {
                        element.classList.remove('show');
                    } else {
                        element.scrollIntoView();
                    }
                });
            });
        });

        new Swiper('.swiper-news', {
            modules: [Scrollbar],
            scrollbar: {
                el: ".swiper-scrollbar",
                hide: false,
                dragSize: 400,
                draggable: true,
            },
            spaceBetween: 22,
            breakpoints: {
                320: {
                    slidesPerView: 1.25,
                    spaceBetween: 10,
                    scrollbar: {
                        dragSize: 100,
                    }
                },
                1024: {
                    slidesPerView: 2.5,
                    spaceBetween: 10,
                    scrollbar: {
                        dragSize: 300,
                    }
                },
                1440: {
                    slidesPerView: 3.75,
                    spaceBetween: 10,
                    scrollbar: {
                        dragSize: 400,
                    }
                },
            }
        });
    });

    Loader.on(null, () => {

        if (!findOne('.swiper-testimonial')) {
            return;
        }

        new Swiper('.swiper-testimonial', {
            modules: [Scrollbar],
            scrollbar: {
                el: ".swiper-scrollbar",
                hide: false,
                dragSize: 400,
                draggable: true,
            },
            slidesPerView: 4.5,
            spaceBetween: 22,
            breakpoints: {
                320: {
                    slidesPerView: 1,
                    spaceBetween: 10
                },
                1024: {
                    slidesPerView: 3.5,
                    spaceBetween: 10
                },
            }
        });
    });

    Loader.on(null, () => {

        if (!findOne('.swiper-leadership')) {
            return;
        }

        new Swiper('.swiper-leadership', {
            modules: [Scrollbar],
            scrollbar: {
                el: ".swiper-scrollbar",
                hide: false,
                dragSize: 400,
                draggable: true,
            },
            slidesPerView: 3.5,
            spaceBetween: 22,
            breakpoints: {
                320: {
                    slidesPerView: 1,
                    spaceBetween: 10
                },
                1024: {
                    slidesPerView: 2.5,
                    spaceBetween: 10
                },
            }
        });
    });

    Loader.on({bodyClass: 'home'}, () => {
        const counter = findOne('#js-counter-numleft') as HTMLElement;

        new Swiper('.number-swiper', {
            modules: [Scrollbar],
            slidesPerView: 1.5,
            scrollbar: {
                el: ".swiper-scrollbar",
                hide: false,
                draggable: true,
            },
            on: {
                realIndexChange(swiper: Swiper) {
                    const slidesLeft = swiper.slides.length - swiper.realIndex - 1;
                    counter.innerText = slidesLeft.toString();
                }
            },
            breakpoints: {
                320: {
                    slidesPerView: 1,
                    spaceBetween: 10
                },
                1024: {
                    slidesPerView: 1.5,
                    spaceBetween: 10
                }
            }
        });
    });


    Loader.on(null, clickableCards);
});


function clickableCards(): void {
    const cards = find('.service-tile-with-hover');

    cards?.forEach((value) => {
        value.addEventListener('click', () => {
            const id: string = value.parentElement.id;
            window.location.pathname = `/industries-served/${id}`;
        });
    });
}
